import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './authContext';
import reportWebVitals from './reportWebVitals';
import { clearStaleCache } from './utils/cacheBuster';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ✅ Clean up old caches/service workers immediately on load
clearStaleCache();

// ✅ Add Global Error Protection (Safe Reload Screen)
window.onerror = (message, source, lineno, colno, error) => {
  // If we detect a fatal JS error during boot (common for old caches),
  // try to reload once and clear storage as a last resort
  console.error("⛔ Global Error Detected:", message);
  const crashCount = parseInt(sessionStorage.getItem('boot_crash_count') || '0');

  if (crashCount < 2) {
    sessionStorage.setItem('boot_crash_count', (crashCount + 1).toString());
    localStorage.clear(); // Clear all state as a safety measure
    window.location.reload();
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <GoogleOAuthProvider clientId="224220160403-6pqbuvsvkgf6lmp9vvomch2uuqvnk84a.apps.googleusercontent.com">
          <AuthProvider>
            <App />
          </AuthProvider>
        </GoogleOAuthProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error("💥 App failed to render:", error);
  // Show a "Safe Reload" UI if the crash happens synchronously
  document.body.innerHTML = `
    <div style="height:100vh; display:flex; flex-direction:column; align-items:center; justify-content:center; background:#000; color:#fff; font-family:sans-serif; text-align:center; padding:20px;">
      <h2 style="color:#6366f1;">App Updated</h2>
      <p>We've refreshed the app to the latest stable version.</p>
      <button onclick="location.reload(true)" style="background:#6366f1; color:white; border:none; padding:12px 24px; border-radius:30px; cursor:pointer; font-weight:bold; margin-top:20px;">
        Refresh Now
      </button>
    </div>
  `;
}

// ✅ Enable PWA Service Worker for cache management
serviceWorkerRegistration.register();

reportWebVitals();

